"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ShareDialogUserActionOptions;
(function (ShareDialogUserActionOptions) {
    ShareDialogUserActionOptions["CloseShareDialog"] = "Close";
    ShareDialogUserActionOptions["CopyEmbedCode"] = "Copy embed code";
    ShareDialogUserActionOptions["CopyLink"] = "Copy link";
    ShareDialogUserActionOptions["OpenShareDialog"] = "Open";
    ShareDialogUserActionOptions["ShareContent"] = "Share content";
    ShareDialogUserActionOptions["ContentCleared"] = "Content cleared";
})(ShareDialogUserActionOptions = exports.ShareDialogUserActionOptions || (exports.ShareDialogUserActionOptions = {}));
var TelemetryService = /** @class */ (function () {
    function TelemetryService() {
    }
    Object.defineProperty(TelemetryService, "Instance", {
        get: function () {
            return this.instance || (this.instance = new this());
        },
        enumerable: true,
        configurable: true
    });
    TelemetryService.prototype.initLogEvent = function (actualLogEvent) {
        TelemetryService.instance.logEvent = actualLogEvent;
    };
    TelemetryService.prototype.log = function (userSelectedAction) {
        if (this.logEvent) {
            this.logEvent(userSelectedAction);
        }
    };
    /**
     * Clear log events - for testing purpose
     */
    TelemetryService.prototype.clearLogEvents = function () {
        if (this.logEvent) {
            this.logEvent = undefined;
        }
    };
    return TelemetryService;
}());
exports.TelemetryService = TelemetryService;
//# sourceMappingURL=TelemetryService.js.map